import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { Filter } from 'labstep-web/constants/filters';

export const filters = [
  Filter.created_by,
  Filter.assigned_to,
  Filter.date_range,
  Filter.tag,
  Filter.deleted,
  Filter.protocol_collection_status,
  Filter.device,
];

export const bulkActions = [
  BulkAction.delete,
  BulkAction.tag,
  BulkAction.transfer_ownership,
  BulkAction.share,
  BulkAction.add_to_folder,
  BulkAction.remove_from_folder,
];
